import React from 'react';
import { IPaymentSelectOption } from 'src/entities/pocket';
import { IServiceSubtotal } from 'src/entities/service';

export interface IReservationEndActions {
    setHasOnlinePocket: (value: boolean) => void;
    setSelectedPayment: (value: IPaymentSelectOption | null) => void;
    setShouldSignUp: (value: boolean) => void;
}

export interface IReservationEndProvidedState {
    hasOnlinePocket: boolean;
    selectedPayment: IPaymentSelectOption | null;
    shouldSignUp: boolean;
    displayedSubtotal: IServiceSubtotal | null;
    actions: IReservationEndActions;
}

export const ReservationEndContext = React.createContext<IReservationEndProvidedState>({
    hasOnlinePocket: false,
    selectedPayment: null,
    shouldSignUp: false,
    displayedSubtotal: null,
    actions: {
        setHasOnlinePocket: () => undefined,
        setSelectedPayment: () => undefined,
        setShouldSignUp: () => undefined
    }
});

export const ReservationEndProvider = ReservationEndContext.Provider;
export const ReservationEndConsumer = ReservationEndContext.Consumer;